import { FaCircle } from "react-icons/fa";
import logo from "../image/logo.png"
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-[#FFFAEC] text-primary w-full">
      <div className="max-w-7xl mx-auto px-6 py-10">

        {/* TOP GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-left md:text-left">

          {/* LOGO */}
          <div className="flex flex-col items-start">
          <Link to="/">  <img src={logo} alt="logo" className="w-40 h-20" /></Link>
            <p className="text-sm text-secondary mt-2 max-w-xs">
              Find your dream job with our powerful job search engine.
            </p>
          </div>

          {/* LINKS 1 */}
          <div>
            <h3 className="font-bold tracking-widest mb-4 inline-block border-b border-secondary text-orange pb-1">
              RESOURCES & LEGAL
            </h3>
            <ul className="space-y-2">
              {[
                { label: "About Us", path: "/about-us" },
                { label: "Contact", path: "/contact-us" },
                { label: "Terms of Use", path: "/terms-of-use" },
                { label: "Privacy Policy", path: "/privacy-policy" },
              ].map((item) => (
                <li
                  key={item.path}
                  className="flex items-center justify-start gap-2 text-sm"
                >
                  <FaCircle size={6} />
                  <Link
                    to={item.path}
                    className="hover:underline cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-bold tracking-widest mb-4 inline-block border-b border-secondary text-orange pb-1">
              CATEGORIES
            </h3>
            <ul className="space-y-2">
              {[{ name: "Development", href: "/technology " },
              { name: "Guides", href: "/guides" },
              { name: "Innovation", href: "/innovation" },
              { name: "Jobs", href: "/" },
              ].map((item) => (
                <li key={item.name} className="flex items-center justify-start gap-2 text-sm">
                  <FaCircle size={6} />
                  <Link
                    to={item.href}
                    className="hover:underline cursor-pointer text-gray-700"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="border-t border-orange my-5"></div>

        {/* COPYRIGHT */}
        <p className="text-center text-sm text-secondary">
          © 2026 Recommand Jobs Hub – All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;